import React from "react"
import { CircularProgress, Grid } from "@mui/material"
import { styled } from "@mui/material/styles"

const RootGrid = styled(Grid)(({ theme }) => ({
  height: "calc(100vh - 227px)",
  width: "100vw",
  [theme.breakpoints.down("xs")]: {
    height: "calc(100vh - 303px)",
  },
}))

const Loading = () => {
  return (
    <RootGrid
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
    >
      <Grid item>
        <CircularProgress />
      </Grid>
    </RootGrid>
  )
}

export default Loading
